import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import query from '@/api/APIServices'
import { CategoryParams } from '@/interfaces/containerCategory'

export const GET_ALL_CATEGORIES_QUERY_KEY = 'categories'
export const GET_CATEGORY_QUERY_KEY = (categoryId: number) => [
  'category',
  categoryId,
]

export function useServerLogisticCategory() {
  const queryClient = useQueryClient()

  const getCategories = () => {
    return useQuery({
      queryKey: [GET_ALL_CATEGORIES_QUERY_KEY],
      queryFn: async () => {
        const response = await query.get('/cargo/category')
        return response.data
      },
    })
  }
  const getCategory = (categoryId: number) => {
    return useQuery({
      queryKey: [GET_CATEGORY_QUERY_KEY, categoryId],
      queryFn: async () => {
        const response = await query.get(`/cargo/category/${categoryId}`)
        return response.data
      },
      enabled: !!categoryId,
    })
  }

  const createCategory = (data: CategoryParams) => {
    return useMutation({
      mutationFn: async () => {
        const response = await query.post('/cargo/category', data)
        return response.data
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [GET_ALL_CATEGORIES_QUERY_KEY],
        })
      },
    })
  }

  const updateCategory = (categoryId: number, data: any) => {
    return useMutation({
      mutationFn: async () => {
        const response = await query.put(`/cargo/category/${categoryId}`, data)
        return response.data
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [
            GET_CATEGORY_QUERY_KEY(categoryId),
            GET_ALL_CATEGORIES_QUERY_KEY,
          ],
        })
      },
    })
  }
  const deleteCategory = (expedientId: number) => {
    return useMutation({
      mutationFn: async () => {
        const response = await query.deleteAPI(`/category/${expedientId}`)
        return response.data
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [GET_ALL_CATEGORIES_QUERY_KEY],
        })
      },
    })
  }
  return {
    getCategories,
    getCategory,
    createCategory,
    updateCategory,
    deleteCategory,
  }
}
